<template>
  <el-dialog
    :title="title"
    append-to-body
    :visible.sync="visible"
    width="60%"
    :before-close="handleClose"
    top="15vh"
  >
    <div class="layout" :style="{height: `${418/scale}px`}">
      <SearchSelect
        @onRemove="handleTagRemove"
        @onAdd="handleTagAdd"
        :isHeadimg="isHeadimg"
        :selectList="selectList" />
      <div class="operate">
        <el-row>
          <el-button type="primary" @click="handleConfirm">确定</el-button>
          <el-button type="info" plain @click="handleClose">取消</el-button>
        </el-row>
      </div>
      <div class="right">
        <Organization
          :selectList="selectList"
          @onToggle="handleToggle"
          @onAll="handleAll"
          :isHeadimg="isHeadimg" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Organization from './organization'
import SearchSelect from './searchSelect'
import Item from './item'
import mixScale from './mixins/scale'
import mixSelectList from './mixins/selectList'
import _ from 'lodash'
import api from './api'
import { getAllIds } from './tree'

export default {
  provide: function() {
    return {
      multiple: this.multiple
    }
  },
  mixins: [mixScale, mixSelectList],
  components: {
    Organization,
    Item,
    SearchSelect
  },
  props: {
    visible: {
      type: Boolean, // sync
      default: false
    },
    selectedItems: {
      type: Array
    },
    title: {
      type: String,
      default: '选择用户'
    },
    multiple: {
      type: Boolean,
      default: true
    },
    isHeadimg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  methods: {
    handleConfirm() {
      const orgList = _.filter(this.selectList, function(o) { return o.orgCode && o.orgCode !== '' })
      const userList = _.filter(this.selectList, function(o) { return o.orgCode === undefined })

      console.log(orgList)

      if (orgList.length && this.multiple) {
        const orgIds = getAllIds(orgList)
        this.getAccountByOrgIds(orgIds, userList)
      } else {
        this.$emit('onChecked', [
          ...this.selectList
        ])
      }

      this.handleClose()
    },
    handleClose(done) {
      this.$emit('update:visible', false)
    },
    async getAccountByOrgIds(orgIds, userList) {
      try {
        const { data } = await api.apiAccountListOrgId({}, null, {
          hasOrg: true,
          orgIdList: orgIds,
          downwardRecursive: true
        })

        if (data.length) {
          data.map(user => {
            const index = _.findIndex(this.selectList, { id: user.id })
            if (index < 0) {
              userList.push(user)
            }
          })
        }

        this.$emit('onChecked', userList)
      } catch ({ msg }) {
        this.$message.error(msg)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './dialog.scss'
</style>
